module.exports = __webpack_public_path__ + "static/media/diamant.e17736bd.png";